import { API_BASE } from "../config/apiBase";

export async function downloadFile({ url, filename, token }) {
    if (!url) return false;

    if (typeof window !== "undefined") {
        window.dispatchEvent(
            new CustomEvent("mooz:downloadStarted", {
                detail: { filename: filename || null, url },
            })
        );
    }

    const apiBase = API_BASE || "";
    const needsAuth = token && apiBase && url.startsWith(apiBase);
    const headers = needsAuth ? { Authorization: `Bearer ${token}` } : undefined;

    const res = await fetch(url, {
        headers,
        credentials: "omit",
    });

    if (!res.ok) {
        throw new Error(`Download failed: ${res.status}`);
    }

    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename || "recording.webm";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
    return true;
}
